export default __webpack_public_path__ + "static/media/20s_storyicon@2x.e25b52d1.png";